module.exports = __webpack_public_path__ + "img/LsgAudio32-34.bf298aa6.jpeg";